import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { Layout } from '../components/layout/layout';
import { ApplicationRoutes } from '../constants/appRoutes';

export const LogoutRouteItem: RouteItem = {
  text: 'Logout',
  layout: <Layout />,
  disableDefaultNavItem: true,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [],
  path: ApplicationRoutes.account.logout,
  async lazy() {
    const component = await import('../features/auth/Logout');
    return { Component: component.Logout };
  }
};

export const MyAccountRouteItem: RouteItem = {
  text: 'My Account',
  layout: <Layout />,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  disableDefaultNavItem: true,
  allowedRoles: [],
  path: ApplicationRoutes.account.myAccount,
  async lazy() {
    const component = await import('../features/auth/MyAccount');
    return { Component: component.MyAccount };
  }
};

export const LoginRouteItem: RouteItem = {
  path: ApplicationRoutes.account.login,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  text: 'Login',
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/auth/Login');
    return { Component: component.LoginPage };
  }
};

export const ForgotPasswordRouteItem: RouteItem = {
  path: ApplicationRoutes.account.forgotPassword,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  text: 'Forgot Password',
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/auth/ForgotPassword');
    return { Component: component.ForgotPasswordPage };
  }
};

export const ResetPasswordRouteItem: RouteItem = {
  path: ApplicationRoutes.account.resetPassword,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/auth/ResetPassword');
    return { Component: component.ResetPasswordPage };
  }
};

export const RegisterRouteItem: RouteItem = {
  path: ApplicationRoutes.account.register,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  text: 'Create Account',
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/auth/Register/Register.tsx');
    return { Component: component.Register };
  }
};
